
import ArrowDown1 from "../../../assets/filled/ArrowDown1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowDown1Icon({ className, dataTestid = "ArrowDown1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowDown1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
